import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { ContactUpdate } from '../pages'
import { contactDetailRoute } from './ContactDetailRoute'

export const contactDetailUpdateRoute = createRoute({
  getParentRoute: () => contactDetailRoute,
  component: () => <ContactUpdate />,
  path: '/update',
  validateSearch: (search) =>
    z
      .object({
        from: z.string().optional()
      })
      .parse(search)
})
